module.exports = __webpack_public_path__ + "files/00ccf29c13ef945a903f77f2284e94fc.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/android-chrome-192x192.png
// module id = 552
// module chunks = 76